import { Section, TableOfContent } from '../../../typings/interfaces';
import { HUNGARIAN } from '../../../assets/images';
// Hungarian
const HUSection: Section[] = [
  {
    name: '1: Referencia és áttekintés',
    subSections: [
      {
        name: 'Előszó',
        page: 3,
      },
      {
        name: 'Cél és a Gyakorlati útmutató használata',
        page: 4,
      },
      {
        name: 'Fontos definíciók',
        page: 5,
      },
      {
        name: 'Ellenőrzések hierarchiája',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFEsaver-elemek',
    subSections: [
      {
        name: 'Gépjármű – közlekedésbiztonság',
        page: 9,
      },
      {
        name: 'Munkavégzés magasban',
        page: 12,
      },
      {
        name: 'Mozgó gépek',
        page: 18,
      },
      {
        name: 'Kizárás és kitáblázás – Az energiaellátás leválasztása',
        page: 22,
      },
      {
        name: 'Villanyszerelési munka',
        page: 25,
      },
      {
        name: 'Zárt tér',
        page: 29,
      },
      {
        name: 'Ömlesztett anyag tárolása',
        page: 32,
      },
      {
        name: 'Vasúti kocsi biztonsága',
        page: 37,
      },
      {
        name: 'Földmunka és árokásás',
        page: 41,
      },
      {
        name: 'Emelés és kötözés',
        page: 45,
      },
      {
        name: 'Veszélyes anyagok',
        page: 49,
      },
      {
        name: 'Tűzveszélyes tevékenység',
        page: 52,
      },
    ],
  },
  {
    name: '3:  További segédanyagok és eszközök',
    subSections: [
      {
        name: `Víz felett vagy körül végzett munka`,
        page: 56,
      },
      {
        name: 'Leejtett vagy leeső tárgyak',
        page: 59,
      },
      {
        name: 'Atmoszféra- és gáztesztelés',
        page: 61,
      },
      {
        name: 'Kémiai veszély kommunikációja',
        page: 63,
      },
    ],
  },
  {
    name: '4: Cargill biztonsági irányítási rendszerek',
    subSections: [
      {
        name: 'Főbb fogalmak',
        page: 70,
      },
      {
        name: 'Súlyos és halálos sérüléssel járó (SIF) események meghatározása',
        page: 72,
      },
      {
        name: 'Potenciálisan súlyos és halálos sérüléssel járó (SIFp) események kategorizálása',
        page: 73,
      },
      {
        name: 'Automatikus SIF-meghatározás kritériumok táblázata ',
        page: 74,
      },
      {
        name: 'Emberi és szervezeti teljesítmény (HOP)',
        page: 76,
      },
    ],
  },
];
const HUTableofContent: TableOfContent = {
  language: 'hu',
  sections: HUSection,
  label: 'Tartalomjegyzék',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide (hu_HU)_DIGITAL_CROPPED.pdf',
  hopPocket: 'HOP-zsebkönyv',
  hopPocketLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_Hungarian.pdf',
  source: HUNGARIAN,
};

export default HUTableofContent;
